import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { track } from "@/lib/site";

export default function ProductCard({ product }) {
  return (
    <article className="card card-hover flex h-full flex-col overflow-hidden" data-testid={`product-card-${product.slug}`}>
      <Link to={`/products/${product.slug}`} className="group relative block aspect-[4/3] overflow-hidden bg-sand" aria-label={`View ${product.name}`}>
        <img
          src={product.image}
          alt={`${product.name} — ${product.short_description}`}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.07]"
        />
        <span className="pointer-events-none absolute inset-x-0 bottom-0 h-[3px] w-0 bg-gold transition-all duration-500 ease-out group-hover:w-full" aria-hidden="true" />
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-gold-dark">
          {(product.category_slug || "").replace(/-/g, " ")}
        </span>
        <h3 className="mt-2 font-serif text-lg font-semibold leading-snug text-navy">
          <Link to={`/products/${product.slug}`} className="hover:text-gold-dark">{product.name}</Link>
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-mist">{product.short_description}</p>
        <div className="mt-4 flex items-center justify-between border-t border-line pt-4">
          <Link
            to={`/products/${product.slug}`}
            data-testid={`product-view-${product.slug}`}
            className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-navy transition-colors hover:text-gold-dark"
          >
            View Product <ArrowRight size={14} />
          </Link>
          <Link
            to={`/quote?product=${encodeURIComponent(product.name)}`}
            data-testid={`product-quote-${product.slug}`}
            onClick={() => track("quote_open", { product: product.name })}
            className="text-xs font-bold uppercase tracking-wider text-gold-dark underline decoration-gold/50 underline-offset-4 transition-colors hover:text-navy"
          >
            Request Quote
          </Link>
        </div>
      </div>
    </article>
  );
}
